/* ================================================================
   SIS Webshop - vergelijken en favorieten
   Ontwikkelaar / Auteur: P.A. Koemans
   Copyright (c) 2026 P.A. Koemans. Alle rechten voorbehouden.
   ================================================================

   Twee lijstjes in de browser van de bezoeker, zonder account:
     vergelijk   hoogstens 4 uitvoeringen, voor /pages/vergelijken
     favorieten  hoogstens 50, met een aantal, voor /pages/favorieten
   Een item is {v: variant-id, h: product-handle, m: modelcode, n: aantal}.

   WAT HIER GEBEURT
   * Elke knop met `data-sis-lijst` (snippet sis-lijstknop) zet zijn item in
     of uit de lijst; `aria-pressed` volgt wat er in de lijst staat, ook in
     een tweede tabblad (het `storage`-signaal).
   * Onderin staat een balk met wat er gekozen is, zodra er iets gekozen is.
   * `haal()` leest de gegevens van een uitvoering uit de alternatieve
     template `product.sisdata` - de specificaties staan in metavelden en
     die geeft /products/<handle>.js niet mee.
   * `inWagen()` legt een of meer artikelen in de winkelwagen.

   ZONDER OPSLAG
   In een privévenster of met geblokkeerde cookies kan localStorage
   ontbreken of een fout geven.  Elke lees- en schrijfactie staat daarom in
   try/catch; de winkel werkt dan gewoon, alleen onthoudt hij niets.
*/
(function () {
  'use strict';
  if (window.SisLijst) { return; }

  var NL = /^nl/i.test(document.documentElement.lang || 'nl');
  var T = NL ? {
    vergelijk: 'Vergelijken', favorieten: 'Favorieten',
    inVergelijk: 'Uit vergelijking halen', inFavorieten: 'Uit favorieten halen',
    naarVergelijk: 'Vergelijken', naarFavorieten: 'Favorieten',
    vol: 'U kunt maximaal 4 producten vergelijken. Haal er eerst een weg.',
    volFav: 'Uw favorietenlijst is vol (50 artikelen).',
    toegevoegdV: 'Toegevoegd aan vergelijken', toegevoegdF: 'Bewaard in favorieten',
    wissen: 'Wissen', sluit: 'Sluiten',
    opVoorraad: 'Op voorraad', verwacht: 'Verwacht', verwachtRond: 'Verwacht rond ',
    bestelbaar: 'Bestelbaar, niet op voorraad', nietLeverbaar: 'Niet leverbaar',
    bezig: 'Bezig...', toegevoegd: 'Toegevoegd', mislukt: 'Toevoegen lukte niet'
  } : {
    vergelijk: 'Compare', favorieten: 'Favourites',
    inVergelijk: 'Remove from comparison', inFavorieten: 'Remove from favourites',
    naarVergelijk: 'Compare', naarFavorieten: 'Favourites',
    vol: 'You can compare up to 4 products. Remove one first.',
    volFav: 'Your favourites list is full (50 items).',
    toegevoegdV: 'Added to comparison', toegevoegdF: 'Saved to favourites',
    wissen: 'Clear', sluit: 'Close',
    opVoorraad: 'In stock', verwacht: 'Expected', verwachtRond: 'Expected around ',
    bestelbaar: 'Available to order, not in stock', nietLeverbaar: 'Not available',
    bezig: 'Adding...', toegevoegd: 'Added', mislukt: 'Could not add'
  };

  var WORTEL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var LIJSTEN = {
    vergelijk:  { sleutel: 'sis.vergelijk',  max: 4,  pagina: 'pages/vergelijken' },
    favorieten: { sleutel: 'sis.favorieten', max: 50, pagina: 'pages/favorieten' }
  };
  var DATA_DUUR = 15 * 60 * 1000;     /* hoe lang een opgehaalde uitvoering meegaat */

  /* De tekens.  Dezelfde als in snippets/sis-lijstknop.liquid; hier nog een
     keer omdat de balk en de lijstpagina's ze in JavaScript opbouwen. */
  var TEKEN = {
    vergelijk: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 4v16M8 20h8M5 7h14"/><circle cx="12" cy="4" r=".6"/><path class="sis-rijicoon__vul" d="M5 7l-3 6.5a3 3 0 0 0 6 0L5 7zM19 7l-3 6.5a3 3 0 0 0 6 0L19 7z"/></svg>',
    favorieten: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path class="sis-rijicoon__vul" d="M12 20.2s-7.4-4.5-9.4-8.8A5 5 0 0 1 12 6.2a5 5 0 0 1 9.4 5.2c-2 4.3-9.4 8.8-9.4 8.8z"/></svg>',
    kruis: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    wagen: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h2.2l2.1 11.2a1.6 1.6 0 0 0 1.6 1.3h8.9a1.6 1.6 0 0 0 1.6-1.3L20 7H5"/><circle cx="9.5" cy="20" r="1.4"/><circle cx="17" cy="20" r="1.4"/></svg>',
    printer: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M7 9V3h10v6"/><rect x="3" y="9" width="18" height="8" rx="1.6"/><path d="M7 14h10v7H7z"/></svg>',
    delen: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1"/><path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1"/></svg>'
  };

  /* ------------------------------------------------------------ opslag */

  function geldig(i) { return i && i.v && i.h; }

  function lees(naam) {
    try {
      var r = JSON.parse(window.localStorage.getItem(LIJSTEN[naam].sleutel) || '[]');
      return Array.isArray(r) ? r.filter(geldig) : [];
    } catch (e) { return []; }
  }

  function schrijf(naam, lijst) {
    try {
      window.localStorage.setItem(LIJSTEN[naam].sleutel,
        JSON.stringify(lijst.slice(0, LIJSTEN[naam].max)));
    } catch (e) { /* geen opslag: dan onthoudt de winkel het niet */ }
    ververs();
  }

  function plek(lijst, v) {
    for (var k = 0; k < lijst.length; k++) {
      if (String(lijst[k].v) === String(v)) { return k; }
    }
    return -1;
  }

  function heeft(naam, v) { return plek(lees(naam), v) >= 0; }

  function voegToe(naam, item) {
    var lijst = lees(naam);
    if (plek(lijst, item.v) >= 0) { return { ok: true }; }
    if (lijst.length >= LIJSTEN[naam].max) {
      return { ok: false, reden: naam === 'vergelijk' ? T.vol : T.volFav };
    }
    lijst.push({ v: String(item.v), h: item.h, m: item.m || '', n: item.n || 1 });
    schrijf(naam, lijst);
    return { ok: true, nieuw: true };
  }

  function verwijder(naam, v) {
    var lijst = lees(naam);
    var i = plek(lijst, v);
    if (i >= 0) { lijst.splice(i, 1); schrijf(naam, lijst); }
  }

  function zetAantal(naam, v, n) {
    var lijst = lees(naam);
    var i = plek(lijst, v);
    if (i >= 0) { lijst[i].n = Math.max(1, parseInt(n, 10) || 1); schrijf(naam, lijst); }
  }

  /* ------------------------------------------------- delen via de URL */

  function deelUrl(naam, lijst) {
    var delen = lijst.map(function (i) {
      return i.h + ':' + i.v + (naam === 'favorieten' ? ':' + (i.n || 1) : '');
    });
    return window.location.origin + WORTEL + LIJSTEN[naam].pagina + '?p=' +
      encodeURIComponent(delen.join(','));
  }

  function uitUrl() {
    var m = /[?&]p=([^&#]*)/.exec(window.location.search);
    if (!m) { return null; }
    var tekst = decodeURIComponent(m[1].replace(/\+/g, ' '));
    return tekst.split(',').map(function (deel) {
      var s = deel.split(':');
      return { h: s[0], v: s[1], m: '', n: parseInt(s[2], 10) || 1 };
    }).filter(function (i) { return /^[a-z0-9-]+$/i.test(i.h || '') && /^\d+$/.test(i.v || ''); });
  }

  /* ------------------------------------------------ gegevens ophalen */

  function haal(item) {
    var sleutel = 'sis.data.' + item.v;
    try {
      var bewaard = JSON.parse(window.sessionStorage.getItem(sleutel) || 'null');
      if (bewaard && Date.now() - bewaard.t < DATA_DUUR) {
        return Promise.resolve(bewaard.d);
      }
    } catch (e) { /* geen sessieopslag: gewoon ophalen */ }
    var adres = WORTEL + 'products/' + encodeURIComponent(item.h) +
      '?variant=' + encodeURIComponent(item.v) + '&view=sisdata';
    return fetch(adres, { credentials: 'same-origin' }).then(function (a) {
      if (!a.ok) { throw new Error('niet gevonden'); }
      return a.text();
    }).then(function (tekst) {
      var d = JSON.parse(tekst);
      /* Bestaat de variant niet meer, dan geeft Shopify de eerste terug.
         Dat is een ander artikel: niet stilletjes tonen. */
      if (String(d.v) !== String(item.v)) { throw new Error('variant vervallen'); }
      try {
        window.sessionStorage.setItem(sleutel, JSON.stringify({ t: Date.now(), d: d }));
      } catch (e) { /* vol of uit: niet erg */ }
      return d;
    });
  }

  /* Alle items tegelijk; een item dat niet meer bestaat krijgt `fout`. */
  function haalAlles(lijst) {
    return Promise.all(lijst.map(function (i) {
      return haal(i).then(function (d) { return { item: i, d: d }; },
                          function () { return { item: i, d: null, fout: true }; });
    }));
  }

  /* ----------------------------------------------------------- lampje */

  function datumTekst(iso) {
    var d = new Date(iso + 'T12:00:00');
    if (isNaN(d)) { return ''; }
    return NL ? ('0' + d.getDate()).slice(-2) + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + d.getFullYear()
              : d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  function voorraadTekst(vr) {
    if (!vr || !vr.s) { return ''; }
    switch (vr.s) {
      case 'groen': return T.opVoorraad;
      case 'geel': return vr.d ? T.verwachtRond + datumTekst(vr.d) : T.verwacht;
      case 'oranje': return T.bestelbaar;
      case 'rood': return T.nietLeverbaar;
    }
    return '';
  }

  /* Zelfde lampje als snippets/sis-voorraad.liquid, als HTML-tekst. */
  function lampje(vr, metTekst) {
    var tekst = voorraadTekst(vr);
    if (!tekst) { return ''; }
    var lamp = '<span class="sis-voorraadlamp sis-led sis-led--' + vr.s +
      '" tabindex="0" role="img" aria-label="' + esc(tekst) + '" data-uitleg="' + esc(tekst) + '"></span>';
    return metTekst ? '<span class="sis-lampregel">' + lamp + '<span>' + esc(tekst) + '</span></span>' : lamp;
  }

  /* Een bedrag in centen, in de valuta van de markt waarin de bezoeker winkelt. */
  function geld(centen) {
    var munt = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(NL ? 'nl-NL' : 'en-GB', { style: 'currency', currency: munt })
        .format((centen || 0) / 100);
    } catch (e) {
      return munt + ' ' + ((centen || 0) / 100).toFixed(2);
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ----------------------------------------------------- winkelwagen */

  function winkelwagen() { return document.querySelector('cart-notification, cart-drawer'); }

  /* Een artikel: via Dawns eigen melding, zoals de modeltabel.  Meer
     artikelen tegelijk: die melding kan maar een regel tonen, dus dan naar
     de winkelwagen zelf. */
  function inWagen(items) {
    var la = winkelwagen();
    var enkel = items.length === 1;
    var body, koppen = { 'Accept': 'application/javascript' };
    if (enkel) {
      body = new FormData();
      body.append('id', items[0].id);
      body.append('quantity', items[0].quantity || 1);
      if (la && typeof la.getSectionsToRender === 'function') {
        body.append('sections', la.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        body.append('sections_url', window.location.pathname);
      }
    } else {
      koppen['Content-Type'] = 'application/json';
      body = JSON.stringify({ items: items });
    }
    return fetch(WORTEL + 'cart/add.js', { method: 'POST', headers: koppen, body: body })
      .then(function (a) {
        return a.json().then(function (u) {
          if (!a.ok) { throw new Error(u.description || u.message || T.mislukt); }
          return u;
        });
      }).then(function (u) {
        if (enkel && la && typeof la.renderContents === 'function') {
          la.renderContents(u);
        } else {
          window.location = WORTEL + 'cart';
        }
        return u;
      });
  }

  /* De knop laat zien wat er gebeurt, en zegt het als het mislukt. */
  function wagenKnop(knop, items) {
    var woord = knop.querySelector('.sis-knop__woord') || knop;
    var oud = woord.textContent;
    knop.disabled = true;
    woord.textContent = T.bezig;
    inWagen(items).then(function () {
      woord.textContent = T.toegevoegd;
      setTimeout(function () { woord.textContent = oud; knop.disabled = false; }, 1800);
    }, function (fout) {
      woord.textContent = oud;
      knop.disabled = false;
      melding(fout.message || T.mislukt);
    });
  }

  /* --------------------------------------------------------- melding */

  var meldingEl, meldingKlok;
  function melding(tekst) {
    if (!meldingEl) {
      meldingEl = document.createElement('div');
      meldingEl.className = 'sis-lijstmelding';
      meldingEl.setAttribute('role', 'status');
      document.body.appendChild(meldingEl);
    }
    meldingEl.textContent = tekst;
    meldingEl.classList.add('is-zichtbaar');
    clearTimeout(meldingKlok);
    meldingKlok = setTimeout(function () { meldingEl.classList.remove('is-zichtbaar'); }, 3200);
  }

  /* ------------------------------------------------------------ knoppen */

  function zetKnoppen() {
    var v = lees('vergelijk'), f = lees('favorieten');
    document.querySelectorAll('[data-sis-lijst]').forEach(function (knop) {
      var naam = knop.getAttribute('data-sis-lijst');
      var aan = plek(naam === 'vergelijk' ? v : f, knop.getAttribute('data-v')) >= 0;
      knop.setAttribute('aria-pressed', aan ? 'true' : 'false');
      knop.classList.toggle('is-actief', aan);
      var uit = naam === 'vergelijk' ? T.vergelijk : (NL ? 'Bewaren in favorieten' : 'Save to favourites');
      var tekst = aan ? (naam === 'vergelijk' ? T.inVergelijk : T.inFavorieten) : uit;
      knop.setAttribute('data-uitleg', tekst);
    });
  }

  document.addEventListener('click', function (e) {
    var knop = e.target.closest && e.target.closest('[data-sis-lijst]');
    if (!knop) { return; }
    e.preventDefault();
    var naam = knop.getAttribute('data-sis-lijst');
    var v = knop.getAttribute('data-v');
    if (heeft(naam, v)) {
      verwijder(naam, v);
      return;
    }
    var uitkomst = voegToe(naam, {
      v: v, h: knop.getAttribute('data-h'), m: knop.getAttribute('data-m')
    });
    if (!uitkomst.ok) { melding(uitkomst.reden); return; }
    if (uitkomst.nieuw) { melding(naam === 'vergelijk' ? T.toegevoegdV : T.toegevoegdF); }
  });

  /* ------------------------------------------------------------- balk */

  var balk;
  function zetBalk() {
    var v = lees('vergelijk'), f = lees('favorieten');
    var pad = window.location.pathname;
    var opV = /\/pages\/vergelijken\/?$/.test(pad);
    var opF = /\/pages\/favorieten\/?$/.test(pad);
    var toonV = v.length && !opV, toonF = f.length && !opF;
    if (!toonV && !toonF) {
      if (balk) { balk.hidden = true; }
      document.documentElement.classList.remove('sis-met-lijstbalk');
      return;
    }
    if (!balk) {
      balk = document.createElement('div');
      balk.className = 'sis-lijstbalk';
      document.body.appendChild(balk);
    }
    var html = '';
    if (toonV) {
      html += '<div class="sis-lijstbalk__deel">' +
        '<span class="sis-lijstbalk__duimen" data-duimen></span>' +
        '<a class="sis-lijstbalk__knop" href="' + WORTEL + LIJSTEN.vergelijk.pagina + '">' +
        TEKEN.vergelijk + '<span>' + T.naarVergelijk + ' (' + v.length + '/4)</span></a>' +
        '<button type="button" class="sis-lijstbalk__wis" data-wis="vergelijk" aria-label="' +
        esc(T.wissen + ' ' + T.vergelijk) + '">' + TEKEN.kruis + '</button></div>';
    }
    if (toonF) {
      html += '<div class="sis-lijstbalk__deel">' +
        '<a class="sis-lijstbalk__knop sis-lijstbalk__knop--licht" href="' + WORTEL + LIJSTEN.favorieten.pagina + '">' +
        TEKEN.favorieten + '<span>' + T.naarFavorieten + ' (' + f.length + ')</span></a></div>';
    }
    balk.innerHTML = html;
    balk.hidden = false;
    document.documentElement.classList.add('sis-met-lijstbalk');
    var duimen = balk.querySelector('[data-duimen]');
    if (duimen) {
      haalAlles(v).then(function (rijen) {
        duimen.innerHTML = rijen.map(function (r) {
          return r.d && r.d.duim
            ? '<img src="' + esc(r.d.duim) + '" alt="' + esc(r.d.model) + '" title="' + esc(r.d.merk + ' ' + r.d.model) + '">'
            : '';
        }).join('');
      });
    }
  }

  document.addEventListener('click', function (e) {
    var wis = e.target.closest && e.target.closest('[data-wis]');
    if (wis) { schrijf(wis.getAttribute('data-wis'), []); }
  });

  /* ------------------------------------------------------ bijwerken */

  var luisteraars = [];
  function ververs() {
    zetKnoppen();
    zetBalk();
    luisteraars.forEach(function (f) { try { f(); } catch (e) { console.warn('[sis-lijst]', e); } });
  }

  window.addEventListener('storage', function (e) {
    if (!e.key || e.key === LIJSTEN.vergelijk.sleutel || e.key === LIJSTEN.favorieten.sleutel) {
      ververs();
    }
  });

  /* --------------------------------------------------------------- stijl */

  var css = [
    '.sis-rijicoon{position:relative;display:inline-flex;align-items:center;justify-content:center;',
    ' width:3.6rem;height:3.6rem;padding:0;border-radius:.8rem;cursor:pointer;vertical-align:middle;',
    ' background:rgb(var(--color-background));color:rgba(var(--color-foreground),.75);',
    ' border:.1rem solid rgba(var(--color-foreground),.22);transition:border-color .12s,color .12s}',
    '.sis-rijicoon svg{width:1.9rem;height:1.9rem}',
    '.sis-rijicoon:hover{border-color:var(--sis-accent,rgb(var(--color-foreground)));color:rgb(var(--color-foreground))}',
    '.sis-rijicoon:focus-visible{outline:.2rem solid var(--sis-accent,rgb(var(--color-foreground)));outline-offset:.2rem}',
    '.sis-rijicoon.is-actief{color:var(--sis-accent,rgb(var(--color-foreground)));border-color:currentColor}',
    '.sis-rijicoon--favorieten.is-actief{color:#d9281e}',
    '.sis-rijicoon.is-actief .sis-rijicoon__vul{fill:currentColor;fill-opacity:.9}',
    '.sis-rijicoon--vergelijk.is-actief .sis-rijicoon__vul{fill-opacity:.3}',
    /* de ballon: links, net als bij het voorraadlampje - de tabel knipt boven af */
    '.sis-rijicoon::after,.sis-voorraadlamp::after{content:attr(data-uitleg);position:absolute;right:calc(100% + .9rem);top:50%;',
    ' transform:translateY(-50%);width:max-content;max-width:24rem;white-space:normal;text-align:left;',
    ' padding:.6rem .9rem;border-radius:.6rem;font-size:1.3rem;line-height:1.4;font-weight:500;',
    ' background:rgb(var(--color-foreground));color:rgb(var(--color-background));',
    ' box-shadow:0 .4rem 1.2rem rgba(0,0,0,.25);opacity:0;visibility:hidden;transition:opacity .12s;',
    ' pointer-events:none;z-index:20}',
    '.sis-rijicoon::before,.sis-voorraadlamp::before{content:"";position:absolute;right:calc(100% + .1rem);top:50%;',
    ' transform:translateY(-50%);border:.45rem solid transparent;border-left-color:rgb(var(--color-foreground));',
    ' opacity:0;visibility:hidden;transition:opacity .12s;pointer-events:none;z-index:20}',
    '.sis-rijicoon:hover::after,.sis-rijicoon:focus-visible::after,.sis-rijicoon:hover::before,.sis-rijicoon:focus-visible::before,',
    '.sis-voorraadlamp:hover::after,.sis-voorraadlamp:focus::after,.sis-voorraadlamp:hover::before,.sis-voorraadlamp:focus::before{opacity:1;visibility:visible}',
    '.sis-rijacties{display:flex;justify-content:flex-end;align-items:center;gap:.6rem;margin-top:.6rem}',
    '.sis-rijacties .sis-toeblink{margin:0}',
    /* het lampje, voor pagina's zonder de modeltabel */
    '.sis-led{display:inline-block;width:.9em;height:.9em;border-radius:50%;flex-shrink:0;',
    ' box-shadow:inset 0 -.12em .2em rgba(0,0,0,.25),0 0 .35em var(--sis-led-gloed)}',
    '.sis-led--groen{background:#1fa33a;--sis-led-gloed:rgba(31,163,58,.55)}',
    '.sis-led--geel{background:#f2c618;--sis-led-gloed:rgba(242,198,24,.6)}',
    '.sis-led--oranje{background:#f07c12;--sis-led-gloed:rgba(240,124,18,.55)}',
    '.sis-led--rood{background:#d9281e;--sis-led-gloed:rgba(217,40,30,.55)}',
    '.sis-voorraadlamp{position:relative;width:1.2rem;height:1.2rem;cursor:help}',
    '.sis-lampregel{display:inline-flex;align-items:center;gap:.6rem}',
    /* de balk onderin */
    '.sis-lijstbalk{position:fixed;left:50%;bottom:1.6rem;transform:translateX(-50%);z-index:90;',
    ' display:flex;gap:.8rem;flex-wrap:wrap;justify-content:center;max-width:calc(100vw - 3.2rem)}',
    '.sis-lijstbalk[hidden]{display:none}',
    '.sis-lijstbalk__deel{display:flex;align-items:center;gap:.6rem;padding:.6rem;border-radius:1.2rem;',
    ' background:rgb(var(--color-background));box-shadow:0 .6rem 2.4rem rgba(0,0,0,.22);',
    ' border:.1rem solid rgba(var(--color-foreground),.12)}',
    '.sis-lijstbalk__duimen{display:flex;gap:.4rem}',
    '.sis-lijstbalk__duimen img{width:3.6rem;height:3.6rem;object-fit:contain;border-radius:.6rem;background:#f6f6f6}',
    '.sis-lijstbalk__knop{display:inline-flex;align-items:center;gap:.6rem;min-height:4rem;padding:0 1.4rem;',
    ' border-radius:.8rem;text-decoration:none;font-size:1.4rem;font-weight:600;white-space:nowrap;',
    ' background:var(--sis-accent,rgb(var(--color-button)));color:var(--sis-accent-op,rgb(var(--color-button-text)))}',
    '.sis-lijstbalk__knop svg{width:1.9rem;height:1.9rem}',
    '.sis-lijstbalk__knop--licht{background:rgb(var(--color-background));color:rgb(var(--color-foreground));',
    ' border:.1rem solid rgba(var(--color-foreground),.22)}',
    '.sis-lijstbalk__knop--licht svg{color:#d9281e}',
    '.sis-lijstbalk__wis{display:inline-flex;width:3.2rem;height:3.2rem;align-items:center;justify-content:center;',
    ' border:0;border-radius:50%;background:transparent;color:rgba(var(--color-foreground),.6);cursor:pointer}',
    '.sis-lijstbalk__wis:hover{background:rgba(var(--color-foreground),.08);color:rgb(var(--color-foreground))}',
    '.sis-lijstbalk__wis svg{width:1.6rem;height:1.6rem}',
    'html.sis-met-lijstbalk body{padding-bottom:8rem}',
    '.sis-lijstmelding{position:fixed;left:50%;bottom:9rem;transform:translate(-50%,1rem);z-index:95;',
    ' padding:1rem 1.6rem;border-radius:.8rem;font-size:1.4rem;max-width:calc(100vw - 3.2rem);',
    ' background:rgb(var(--color-foreground));color:rgb(var(--color-background));',
    ' box-shadow:0 .4rem 1.2rem rgba(0,0,0,.25);opacity:0;visibility:hidden;transition:opacity .15s,transform .15s}',
    '.sis-lijstmelding.is-zichtbaar{opacity:1;visibility:visible;transform:translate(-50%,0)}',
    '@media (max-width:749px){.sis-lijstbalk__duimen{display:none}.sis-lijstbalk{bottom:1rem}}',
    '@media print{.sis-lijstbalk,.sis-lijstmelding{display:none!important}html.sis-met-lijstbalk body{padding-bottom:0}}'
  ].join('\n');
  var stijl = document.createElement('style');
  stijl.setAttribute('data-sis-lijstjes', '');
  stijl.textContent = css;
  document.head.appendChild(stijl);

  window.SisLijst = {
    T: T, NL: NL, WORTEL: WORTEL, TEKEN: TEKEN, LIJSTEN: LIJSTEN,
    lees: lees, schrijf: schrijf, voegToe: voegToe, verwijder: verwijder,
    zetAantal: zetAantal, heeft: heeft,
    haal: haal, haalAlles: haalAlles,
    deelUrl: deelUrl, uitUrl: uitUrl,
    lampje: lampje, voorraadTekst: voorraadTekst, datumTekst: datumTekst, esc: esc, geld: geld,
    inWagen: inWagen, wagenKnop: wagenKnop, melding: melding,
    ververs: zetKnoppen,
    bijWijziging: function (f) { luisteraars.push(f); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ververs);
  } else {
    ververs();
  }
})();
